import React, { memo, useContext, useState } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import {
    Collapse,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    styled,
    useTheme,
} from '@mui/material'
import { ExpandLessIcon, ExpandMoreIcon } from '../components'
import { translate } from '../i18n'
import { LayoutContext } from '../layout'
import { RouteListItemProps } from './RouteListItem.types'
import RouteList from './RouteList'

const CustomListItemIcon = styled(ListItemIcon)(({ theme }) => ({
    minWidth: theme.spacing(5),
    color: theme.palette.primary.main,
}))

function RouteListItem({ index, route, inner }: RouteListItemProps) {
    const theme = useTheme()
    const [open, setOpen] = useState<boolean>(false)
    const layoutContext = useContext(LayoutContext)

    if (route.path) {
        return (
            <ListItemButton
                key={index}
                onClick={layoutContext.closeDrawer}
                component={RouterLink}
                to={route.path}
                sx={inner ? { pl: 4 } : undefined}
            >
                <CustomListItemIcon>{route.icon}</CustomListItemIcon>
                <ListItemText
                    primary={translate(route.title)}
                    primaryTypographyProps={{
                        variant: 'body1',
                        color: theme.palette.primary.main,
                        fontWeight: '600',
                    }}
                />
            </ListItemButton>
        )
    }

    return (
        <div>
            <ListItemButton key={index} onClick={() => setOpen(!open)}>
                <CustomListItemIcon>{route.icon}</CustomListItemIcon>
                <ListItemText
                    primary={translate(route.title)}
                    primaryTypographyProps={{
                        variant: 'body1',
                        color: theme.palette.primary.main,
                        fontWeight: '600',
                    }}
                />
                {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </ListItemButton>
            {route.items && route.items.length > 0 && (
                <Collapse in={open} timeout="auto" unmountOnExit>
                    <RouteList routes={route.items} inner />
                </Collapse>
            )}
        </div>
    )
}

export default memo(RouteListItem)
